import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("8d074a190c", "._0ebd6d9bf8b95794__wrapper{display:contents}");
}
export default {"wrapper":"_0ebd6d9bf8b95794__wrapper"};
